@if (config && !config.showLoader && !config.noData) {
    <div class="risk-matrix-container">
        <div class="matrix-area">
            @if (showSummary) {
                @if (enableSummaryClick) {
                    <cerrix-riskmatrix-summary
                        [matrix]="matrix"
                        [cellSize]="cellSize"
                        (cellClick)="drillDownFromCell($event)"
                        (summaryClick)="drillDownFromSummary($event)"
                    ></cerrix-riskmatrix-summary>
                } @else {
                    <cerrix-riskmatrix-summary
                        [matrix]="matrix"
                        [cellSize]="cellSize"
                        (cellClick)="drillDownFromCell($event)"
                    ></cerrix-riskmatrix-summary>
                }
            } @else {
                <div class="matrix-only">
                    <div class="matrix">
                        <cerrix-riskmatrix
                            [matrix]="matrix"
                            [cellSize]="cellSize"
                            [highlightSelection]="false"
                            (selectedChange)="drillDownFromCell($event)"
                        ></cerrix-riskmatrix>
                    </div>
                </div>
            }
        </div>
        @if (showLegend) {
            <div class="legend-area">
                @if (matrix.likelihoodInfo && matrix.likelihoodInfo.length > 0) {
                    <div class="likelihood-legend">
                        <div class="title">{{ 'dashboard.riskMatrixWidget.likelihoodLegendTitle' | transloco }}</div>
                        @for (info of matrix.likelihoodInfo; track info; let i = $index) {
                            <div
                                class="value"
                                [title]="
                                    info.Name + (info.Description ? '\n' + info.Description : '')
                                "
                            >
                                {{
                                    info.Name.startsWith(i + 1 + ". ")
                                        ? info.Name
                                        : i + 1 + ". " + info.Name
                                }}
                            </div>
                        }
                    </div>
                }
                @if (matrix.impactInfo && matrix.impactInfo.length > 0) {
                    <div class="impact-legend">
                        <div class="title">
                            {{ matrix.customImpactName ? matrix.customImpactName : ('dashboard.riskMatrixWidget.impactLegendTitle' | transloco) }}
                        </div>
                        @for (info of matrix.impactInfo; track info; let i = $index) {
                            <div
                                class="value"
                                [title]="
                                    info.Name + (info.Description ? '\n' + info.Description : '')
                                "
                            >
                                {{
                                    info.Name.startsWith(i + 1 + ". ")
                                        ? info.Name
                                        : i + 1 + ". " + info.Name
                                }}
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
